// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.notes[data-v-40e66110] {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  line-height: 1.8;\n}\n.cardCollapse__note[data-v-40e66110] {\n  margin-top: 1.875rem;\n}\n.introductionCard[data-v-40e66110] {\n  padding: 20px;\n}\n\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
